import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdvisors = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3332 4.00308C16.7064 4 16.0408 4 15.3332 4C9.36205 4 6.37649 4 4.52149 5.85499C2.6665 7.70999 2.6665 10.6955 2.6665 16.6667C2.6665 22.6377 2.6665 25.6233 4.52149 27.4784C6.37649 29.3333 9.36205 29.3333 15.3332 29.3333C21.3042 29.3333 24.2898 29.3333 26.1449 27.4784C27.9998 25.6233 27.9998 22.6377 27.9998 16.6667C27.9998 15.9591 27.9998 15.2935 27.9968 14.6667",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6667 2.6665L25.0105 3.59588C25.4615 4.81453 25.6869 5.42386 26.1315 5.86836C26.576 6.31286 27.1853 6.53833 28.404 6.98928L29.3333 7.33317L28.404 7.67706C27.1853 8.12801 26.576 8.35349 26.1315 8.79798C25.6869 9.24248 25.4615 9.85181 25.0105 11.0705L24.6667 11.9998L24.3228 11.0705C23.8719 9.85181 23.6464 9.24248 23.2019 8.79798C22.7573 8.35349 22.148 8.12801 20.9293 7.67706L20 7.33317L20.9293 6.98928C22.148 6.53833 22.7573 6.31286 23.2019 5.86836C23.6464 5.42386 23.8719 4.81453 24.3228 3.59588L24.6667 2.6665Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.3335 23.3333C12.4424 20.0771 18.1911 19.9237 21.3335 23.3333M18.6603 13.3333C18.6603 15.1743 17.1658 16.6667 15.3222 16.6667C13.4787 16.6667 11.9841 15.1743 11.9841 13.3333C11.9841 11.4924 13.4787 10 15.3222 10C17.1658 10 18.6603 11.4924 18.6603 13.3333Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgAdvisors;
